import React from 'react'
import { SoundProps } from '../../../../types/sound'
import { API_HOST } from '../../../config'
import styles from '../media.module.scss'
import BtnPlay from '@components/app/button-play'
import PlayerCtx from '@data/contexts/player'


interface Props {
  className?: string
  sound: SoundProps
  disabled?: boolean
  size?: string
}

const PlayBtn = ({ className, sound, disabled, size }: Props) => {
  const {
    isLoading,
    isPlaying,
    nowPlaying,
    play,
    pause,
  } = PlayerCtx.useContainer()

  const isThis = nowPlaying.track.id === sound.id
  const onClick = () => {
    if (isThis && isPlaying) {
      pause()
      return
    }

    play({
      id: sound.id,
      title: sound.title,
      slug: sound.slug,
      user: sound.user.name,
      coverart: sound.coverart_crop_url,
      waveformUrl: sound.waveform_url,
      duration: sound.metadata.duration,
      webmUrl: `${API_HOST}/sounds/${sound.id}.webm`,
      mp3Url: `${API_HOST}/sounds/${sound.id}.mp3`,
      hlsUrl: `${API_HOST}/sounds/${sound.id}.m3u8`,
      limit: sound.limit,
    })
  }

  return (
    <BtnPlay
      size={size}
      className={`${styles.headingPlayBtn} ${className}`}
      isLoading={isThis && isLoading}
      isPlaying={isThis && isPlaying}
      onClick={onClick}
      disabled={disabled}
    />
  )
}

PlayBtn.defaultProps = {
  className: '',
  disabled: false,
  size: '3.5rem',
}

export default PlayBtn
